import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { TicketEditState } from '../models/tickets.models';
import * as selectors from '../selectors/edit-ticket.selectors';

@Injectable({ providedIn: 'root' })
export class EditTicketFacadeService extends FacadeService {
  constructor(public override store: Store<TicketEditState>) {
    super(store);
  }

  // OBSERVABLES
  ticket$ = this.storeSelect(selectors.getTicket);
  ticketSeverityValues$ = this.storeSelect(selectors.getTicketSeverityValues);
  ticketSeverity$ = this.storeSelect(selectors.getTicketSeverity);
  statusValues$ = this.storeSelect(selectors.getStatusValues);
  status$ = this.storeSelect(selectors.getStatus);
  countryValues$ = this.storeSelect(selectors.getCountryValues);
  country$ = this.storeSelect(selectors.getCountry);
  categoryValues$ = this.storeSelect(selectors.getCategoryValues);
  category$ = this.storeSelect(selectors.getCategory);
  assigneeValues$ = this.storeSelect(selectors.getAssigneeValues);
  assignee$ = this.storeSelect(selectors.getAssignee);
  body$ = this.storeSelect(selectors.getBody);
  subject$ = this.storeSelect(selectors.getSubject);
  searchField$ = this.storeSelect(selectors.getSearchField);
  isCreateNewTicket$ = this.storeSelect(selectors.getIsCreateNewTicket);
  isEditTicket$ = this.storeSelect(selectors.getIsEditTicket);
  categoryValidation$ = this.storeSelect(selectors.getCategoryValidation);
  subjectValidation$ = this.storeSelect(selectors.getSubjectValidation);
  countryValidation$ = this.storeSelect(selectors.getCountryValidation);
  bodyValidation$ = this.storeSelect(selectors.getBodyValidation);
  noCustomerAdded$ = this.storeSelect(selectors.getNoCustomerAdded);
  customerAdded$ = this.storeSelect(selectors.getCustomerAdded);
  loyaltyCardLength$ = this.storeSelect(selectors.getLoyaltyCardLength);
  member$ = this.storeSelect(selectors.getMember);
  memberColumns$ = this.storeSelect(selectors.getMemberColumns);
  statusValidation$ = this.storeSelect(selectors.getStatusValidation);
  assigneeValidation$ = this.storeSelect(selectors.getAssigneeValidation);
  severityValidation$ = this.storeSelect(selectors.getSeverityValidation);
  createTicketValidation$ = this.storeSelect(selectors.getCreateTicketValidation);
  updateTicketValidation$ = this.storeSelect(selectors.getUpdateTicketValidation);
  executeFlow$ = this.storeSelect(selectors.getExecuteFlow);

  // OBSERVABLES VALUES
  get ticket() {
    return this.storeSnapshot(this.ticket$);
  }

  get ticketSeverityValues() {
    return this.storeSnapshot(this.ticketSeverityValues$);
  }

  get statusValues() {
    return this.storeSnapshot(this.statusValues$);
  }

  get countryValues() {
    return this.storeSnapshot(this.countryValues$);
  }

  get categoryValues() {
    return this.storeSnapshot(this.categoryValues$);
  }

  get assigneeValues() {
    return this.storeSnapshot(this.assigneeValues$);
  }

  get ticketSeverity() {
    return this.storeSnapshot(this.ticketSeverity$);
  }

  get status() {
    return this.storeSnapshot(this.status$);
  }

  get country() {
    return this.storeSnapshot(this.country$);
  }

  get category() {
    return this.storeSnapshot(this.category$);
  }

  get assignee() {
    return this.storeSnapshot(this.assignee$);
  }

  get body() {
    return this.storeSnapshot(this.body$);
  }

  get subject() {
    return this.storeSnapshot(this.subject$);
  }

  get searchField() {
    return this.storeSnapshot(this.searchField$);
  }

  get member() {
    return this.storeSnapshot(this.member$);
  }

  get createTicketValidation() {
    return this.storeSnapshot(this.createTicketValidation$);
  }

  get updateTicketValidation() {
    return this.storeSnapshot(this.updateTicketValidation$);
  }

  get executeFlow() {
    return this.storeSnapshot(this.executeFlow$);
  }
}
